/* Beleaev Summer promotion, 14-31 August 2026. One-time purchases only. */
(function(){
  'use strict';
  if(window.__beleaevSummerSitewideV1){return;}
  window.__beleaevSummerSitewideV1=true;

  var START=Date.parse('2026-08-13T23:00:00Z');
  var END=Date.parse('2026-08-31T23:00:00Z');
  var params=new URLSearchParams(window.location.search);
  var preview=params.get('summer')==='1'&&params.get('qa')==='blv-summer-aug26-9f4c7a';
  var now=Date.now();
  if(!preview&&(now<START||now>=END)){return;}

  var rates={"57087972999545":15,"57087973032313":15,"57087973065081":20,"57087973097849":20,"57087973130617":20,"45765945950450":15,"45765945983218":15,"45765946015986":20,"45765946048754":20,"45765946081522":20,"57125755486585":15,"57125755519353":15,"57125755552121":20,"57125755584889":20,"57125755617657":20,"57126073467257":15,"57126073500025":15,"57126073532793":20,"57126073565561":20,"57126073598329":20,"45765935431922":15,"45765935464690":15,"45765935497458":20,"45765935530226":20,"45765935562994":20,"45765912592626":15,"45765912625394":15,"45765912658162":20,"45765912690930":20,"45765912723698":20,"45571165421810":15,"45571165454578":15,"45571165487346":20,"45571165520114":20,"45571165552882":20,"56466789433721":20,"56466789466489":20,"57216042172793":15,"57216042205561":15,"57216042238329":20,"57216042271097":20,"57216042303865":20,"56332689637753":15,"56332689670521":15,"56332689703289":20,"56332689736057":20,"56332689768825":20,"57216042893689":15,"57216042926457":15,"57216042959225":20,"57216042991993":20,"57216043024761":20,"57216043090297":15,"57216043123065":15,"57216043155833":20,"57216043188601":20,"57216043221369":20,"56332610240889":15,"56332610273657":15,"56332610306425":20,"56332610339193":20,"56332610371961":20,"56332675187065":15,"56332675219833":15,"56332675252601":20,"56332675285369":20,"56332675318137":20,"56332661948793":15,"56332661981561":15,"56332662014329":20,"56332662047097":20,"56332662079865":20,"56342236037497":20,"56342236070265":20,"63765802647929":20,"63838894817657":15,"63766045589881":20,"56277809889657":15,"56277506752889":20,"56277780005241":20,"63853188219257":15,"63964037218681":20,"63880515453305":20,"63853188088185":20,"63838894326137":10,"63880515256697":20,"57222813843833":20,"57222810993017":20,"57373961224569":10,"57373907222905":10,"57373961191801":10,"57374006182265":10,"57373961257337":10,"57374006247801":10,"57373909320057":20,"57222810665337":20,"57373792141689":20,"57373935698297":20,"57373961617785":10,"57373961716089":20,"57373917675897":10,"57373935862137":15,"57373936091513":20,"57371186463097":20,"57373791879545":20,"57373909680505":20,"57373906469241":15,"57222814400889":10,"57222814105977":20,"57373791977849":20,"57373933273465":15,"57373906076025":10,"57373792108921":20,"57371232043385":20,"57373954441593":10,"57373961486713":15,"57373961585017":15,"57222808437113":15,"57374006149497":10,"57373933044089":15,"57373909844345":15,"57223122649465":10,"57373792272761":10,"57223121895801":10,"57373961322873":10,"56260198007161":10,"57373934092665":15,"57373908730233":15,"57373936255353":10,"57373936419193":10,"57373936517497":15,"57374006280569":10,"57373939532153":10,"57373962240377":10,"57373933437305":15,"57373933601145":15,"57373908926841":15,"57222813155705":15,"57373829824889":10,"57373968302457":15,"57222812467577":10,"56260191191417":15,"57373933896057":15,"57373792305529":10,"57373962469753":10,"57373968171385":10,"57373968236921":10,"57373968204153":10,"57373968138617":15,"56260192960889":15,"57373936451961":15,"57222811353465":15,"57373935534457":10,"57373934289273":10,"57373934518649":10,"57373935370617":10,"57373935206777":10,"57371205730681":10,"57222811156857":10,"57373792600441":10,"57373934059897":10,"57222813647225":10,"56486463144313":10,"55103743263097":10,"56802617753977":10,"57184184140153":10,"55103821644153":10,"45767389577458":10};
  window.BeleaevSummerPromo={active:true,start:START,end:END,rates:rates};

  function money(cents){
    var currency=(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)||'GBP';
    try{return new Intl.NumberFormat('en-GB',{style:'currency',currency:currency}).format(cents/100);}
    catch(error){return '\u00A3'+(cents/100).toFixed(2);}
  }

  function variants(card){
    var source=card.getAttribute('data-blv-summer-variants')||'';
    return source.split(',').map(function(pair){
      var bits=pair.split(':');
      return {id:String(bits[0]||''),price:Number(bits[1]||0)};
    }).filter(function(variant){return variant.id&&variant.price>0&&Number(rates[variant.id]||0)>0;});
  }

  function render(card){
    if(card&&card.closest&&card.closest('.bsl')){return;}
    if(!card||card.getAttribute('data-blv-summer-ready')==='1'){return;}
    card.setAttribute('data-blv-summer-ready','1');
    var eligible=variants(card);
    if(!eligible.length){return;}

    var offers=eligible.map(function(variant){
      var rate=Number(rates[variant.id]);
      return {id:variant.id,was:variant.price,now:Math.round(variant.price*(100-rate)/100),rate:rate};
    }).sort(function(a,b){return a.now-b.now;});
    var offer=offers[0];
    var rateValues=offers.map(function(item){return item.rate;});
    var minRate=Math.min.apply(Math,rateValues);
    var maxRate=Math.max.apply(Math,rateValues);
    var prefix=offers.length>1?'From ':'';
    var badgeText=minRate===maxRate?'\u2212'+maxRate+'%':'\u2212 up to '+maxRate+'%';
    var price=card.querySelector('.price');
    if(!price){return;}

    var promo=document.createElement('div');
    promo.className='blv-summer-card-price';
    promo.innerHTML='<span class="blv-summer-card-price__now">'+prefix+money(offer.now)+'</span><s class="blv-summer-card-price__was">'+prefix+money(offer.was)+'</s>';
    price.appendChild(promo);

    var imageHost=card.querySelector('.card__inner')||card.querySelector('.card');
    if(imageHost){
      var badge=document.createElement('span');
      badge.className='blv-summer-card-badge';
      badge.textContent=badgeText;
      imageHost.appendChild(badge);
    }
    card.setAttribute('data-blv-summer-applied','true');
  }

  /* Beleaev Summer caviar picker, 2026-08-14. Display only; cart pricing stays native Shopify. */
  function renderCaviarPicker(info){
    if(!info||info.getAttribute('data-blv-summer-picker-ready')==='1'){return;}
    var json=info.querySelector('script[id^="ProductJson-"]');
    var picker=info.querySelector('fieldset .variant-list');
    if(!json||!picker){return;}

    var product;
    try{product=JSON.parse(json.textContent);}catch(error){return;}
    if(!product||product.type!=='Caviar'){return;}

    var eligible=(product.variants||[]).filter(function(variant){return Number(rates[String(variant.id)]||0)>0;});
    if(!eligible.length){return;}

    var legend=picker.closest('fieldset')&&picker.closest('fieldset').querySelector('legend.form__label');
    if(legend&&!legend.parentElement.querySelector('.blv-summer-size-hint')){
      var hint=document.createElement('p');
      hint.className='blv-summer-size-hint';
      hint.textContent='The larger the size, the greater the Summer saving.';
      legend.insertAdjacentElement('afterend',hint);
    }

    if(info.closest('quick-add-modal')){
      eligible.forEach(function(variant){
        var input=info.querySelector('.variant-input[value="'+variant.id+'"]');
        var label=input&&info.querySelector('label[for="'+input.id+'"]');
        var price=label&&label.querySelector('.variant-price');
        if(!label||!price||price.getAttribute('data-blv-summer-price-ready')==='1'){return;}
        var rate=Number(rates[String(variant.id)]||0);
        var was=Number(variant.price||0);
        var discounted=was-Math.floor(was*rate/100);
        label.classList.add('blv-summer-quick-label');
        price.classList.add('blv-summer-quick-price');
        price.innerHTML='<span class="blv-summer-quick-price__now">'+money(discounted)+'</span><s class="blv-summer-quick-price__was">'+money(was)+'</s><span class="blv-summer-quick-price__badge">SUMMER \u2212'+rate+'%</span>';
        price.setAttribute('data-blv-summer-price-ready','1');
      });
    }

    info.setAttribute('data-blv-summer-picker-ready','1');
  }

  function scan(root){
    var scope=root&&root.querySelectorAll?root:document;
    scope.querySelectorAll('[data-blv-summer-card]').forEach(render);
    if(scope.matches&&scope.matches('[data-blv-summer-card]')){render(scope);}
    scope.querySelectorAll('product-info').forEach(renderCaviarPicker);
    if(scope.matches&&scope.matches('product-info')){renderCaviarPicker(scope);}
    var parentInfo=scope.closest&&scope.closest('product-info');
    if(parentInfo){renderCaviarPicker(parentInfo);}
  }

  function boot(){
    scan(document);
    var observer=new MutationObserver(function(records){
      records.forEach(function(record){record.addedNodes.forEach(function(node){if(node.nodeType===1){scan(node);}});});
    });
    observer.observe(document.documentElement,{childList:true,subtree:true});
  }

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot,{once:true});}
  else{boot();}
})();

/* Beleaev Summer Quick Add total structure, 2026-08-14. */
(function(){
  'use strict';
  if(window.__blvSummerQuickTotalV1){return;}
  window.__blvSummerQuickTotalV1=true;
  var promo=window.BeleaevSummerPromo;
  if(!promo||!promo.active){return;}

  function money(cents){
    var currency=(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)||'GBP';
    try{return new Intl.NumberFormat('en-GB',{style:'currency',currency:currency}).format(cents/100);}
    catch(error){return '\u00A3'+(cents/100).toFixed(2);}
  }

  function wire(info){
    if(!info||!info.closest('quick-add-modal')||info.getAttribute('data-blv-summer-total-wired')==='1'){return;}
    var json=info.querySelector('script[id^="ProductJson-"]');
    var total=info.querySelector('[data-beleaev-total]');
    if(!json||!total){return;}

    var product;
    try{product=JSON.parse(json.textContent);}catch(error){return;}
    if(!product||product.type!=='Caviar'){return;}

    var variants={};
    (product.variants||[]).forEach(function(variant){variants[String(variant.id)]=variant;});
    var painting=false;

    function paint(){
      if(painting){return;}
      var input=info.querySelector('.variant-input:checked');
      var variant=input&&variants[String(input.value)];
      var rate=variant&&Number(promo.rates[String(variant.id)]||0);
      if(!variant||!rate){return;}

      var quantity=info.querySelector('quantity-input input[type="number"], .product-form__buttons input[name="quantity"]');
      var qty=Math.max(1,parseInt(quantity&&quantity.value||'1',10)||1);
      var unit=Number(variant.price||0);
      var was=unit*qty;
      var now=(unit-Math.floor(unit*rate/100))*qty;
      var html='<span class="blv-summer-pdp-price__now" style="color:#E5C977!important;font-weight:700!important;">'+money(now)+'</span>'+
        '<s class="blv-summer-pdp-price__was" style="color:#C9C9C9!important;font-size:19px!important;font-weight:400!important;text-decoration:line-through!important;text-decoration-thickness:1px!important;">'+money(was)+'</s>'+
        '<span class="blv-summer-pdp-price__badge" style="color:#F3D879!important;font-size:13px!important;letter-spacing:1px!important;">SUMMER \u2212'+rate+'%</span>';

      painting=true;
      total.classList.add('blv-summer-pdp-price__line');
      total.setAttribute('data-unit-cents',String(unit));
      if(total.innerHTML!==html){total.innerHTML=html;}
      painting=false;
    }

    var timer=0;
    function schedule(){
      clearTimeout(timer);
      paint();
      setTimeout(paint,120);
      timer=setTimeout(paint,360);
    }

    info.addEventListener('change',function(event){
      if(event.target&&event.target.matches('.variant-input, quantity-input input, input[name="quantity"]')){schedule();}
    });
    info.addEventListener('input',function(event){
      if(event.target&&event.target.matches('quantity-input input, input[name="quantity"]')){schedule();}
    });
    info.addEventListener('click',function(event){
      var button=event.target&&event.target.closest&&event.target.closest('quantity-input button');
      if(button){setTimeout(schedule,0);}
    });
    new MutationObserver(function(){if(!painting){setTimeout(paint,0);}}).observe(total,{childList:true,characterData:true,subtree:true});
    info.setAttribute('data-blv-summer-total-wired','1');
    schedule();
  }

  function scan(root){
    var scope=root&&root.querySelectorAll?root:document;
    scope.querySelectorAll('quick-add-modal product-info').forEach(wire);
    if(scope.matches&&scope.matches('quick-add-modal product-info')){wire(scope);}
  }

  scan(document);
  new MutationObserver(function(records){
    records.forEach(function(record){record.addedNodes.forEach(function(node){if(node.nodeType===1){scan(node);}});});
  }).observe(document.documentElement,{childList:true,subtree:true});
})();